import CustomizeDataEditorProperty from './CustomizeDataEditorProperty';

export default CustomizeDataEditorProperty;
export { CustomizeDataEditorProperty };
